import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { getScoredModels, getUser, getUsersScore } from "../../state/actions";
import { ActionBtnNav } from "./ActionBtnNav";
import default_image from "../../images/user-profile.svg";
import DropDown from "./DropDown";
import { Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Auth from "../../modules/Auth";
import "./navbar.style.scss";
import { NavbarContact } from "./NavbarContact";
import { User } from "../../types/user";
import useCroqeeTutorial from "../../hooks/useCroqeeTutorial";
import Logo from "./Logo";
import { calcCanvasAndModelDim } from "../../lib/CalcCanvasAndModelDim";

export const COMPETES_URL = "/competes";

interface Props {
  getUser: () => void;
  isAuthenticated: boolean;
  user: User;
  getUsersScore: (num?: number) => void;
  getScoredModels: () => void;
}

const Navbar = ({ isAuthenticated, getUser, getUsersScore, user, isDrawingResultShowing, leftHand }: Props & any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [navOpen, setNavOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const { setIsCroqeeTutorialDone } = useCroqeeTutorial();
  const { isWrapped } = calcCanvasAndModelDim();

  useEffect(() => {
    if (Auth.isUserAuthenticated()) {
      if (isAuthenticated) {
        getUsersScore();
      } else {
        getUser();
      }
    }
  }, [isAuthenticated, getUser, getUsersScore]);

  const checkBoxHandler = (e) => {
    setNavOpen(!navOpen);
  };

  const handleDropdown = () => {
    setDropdown(!dropdown);
  };

  let styles = {
    orange: {
      color: "#06b3cf",
      fontWeight: 600,
    },
    lightBlue: {
      color: "#06b3cf",
      fontWeight: 600,
    },
  };

  const currentPath = location.pathname;

  return (
    <>
      {( (!(isDrawingResultShowing && leftHand)) || isWrapped) && <Logo />}
      {((!isDrawingResultShowing && !isWrapped) || isWrapped) && (<div className="nav">
        <input
          type="checkbox"
          id="nav-check"
          checked={navOpen}
          onChange={checkBoxHandler}
        />
        <button type="button" className="hamburger">
          <label htmlFor="nav-check">
            <div className="menuicon-bg">
              {navOpen ? (
                <CloseIcon
                  sx={{ width: 56, height: "auto", color: "#020202" }}
                />
              ) : (
                <MenuIcon
                  sx={{ width: 56, height: "auto", color: "#020202" }}
                />
              )}
            </div>
          </label>
        </button>
        <div className="nav-links">
          {isAuthenticated ? (
            <>
              <Link
                className="nav-link"
                to="/"
                style={currentPath === "/" ? styles.lightBlue : {}}
              >
                Home
              </Link>
              <Link
                className="nav-link"
                to="/leaderboard"
                style={currentPath === "/leaderboard" ? styles.lightBlue : {}}
              >
                Leaderboard
              </Link>
              <span className="nav-link">
                <div className="profile-nav">
                  <div className="user-img">
                    {user?.img ? (
                      <Avatar
                        src={
                          `${process.env.REACT_APP_CROQEE_SERVER_URL}/user-image/` +
                          user?.img.image_data
                        }
                        alt="profile image"
                      />
                    ) : (
                      <Avatar src={default_image} alt="profile image" />
                    )}
                  </div>
                  <div className="user-dropdown-wrapper">
                    <div className="user-name" onClick={handleDropdown}>
                      {user?.name}
                      <span className={dropdown ? "arrow up" : "arrow down"} />
                    </div>
                    <div
                      className={`profile-list ${dropdown ? "open" : "close"}`}
                    >
                      <DropDown setNavOpen={() => setNavOpen(false)} />
                    </div>
                  </div>
                </div>
              </span>
            </>
          ) : (
            <>
              <Link
                className="nav-link"
                to="/"
                style={currentPath === "/" ? styles.lightBlue : {}}
              >
                Home
              </Link>
              <Link
                className="nav-link"
                to="/signup"
                style={currentPath === "/signup" ? styles.lightBlue : {}}
              >
                Sign up
              </Link>
              <Link
                className="nav-link"
                to="/login"
                style={currentPath === "/login" ? styles.lightBlue : {}}
              >
                Login
              </Link>
            </>
          )}
          <ActionBtnNav
            onclick={() => navigate(COMPETES_URL)}
            endIcon={
              <i
                style={{ marginLeft: "0.5rem" }}
                className="fas fa-arrow-right"
              ></i>
            }
            btnText={"Live Drawing Contest"}
          />
          <Link
            onClick={() => {
              setIsCroqeeTutorialDone(false);
              navigate("/");
              setNavOpen(false);
            }}
            className="nav-link"
            to="/"
          >
            Getting Started Guide
          </Link>
          <NavbarContact />
        </div>
      </div>)}
    </>
  );
};

const mapStateToProps = (state) => {
  const { isAuthenticated, user, isDrawingResultShowing, leftHand } = state;
  return { isAuthenticated, user, isDrawingResultShowing, leftHand };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUser: () => dispatch(getUser()),
    getUsersScore: () => dispatch(getUsersScore()),
    getScoredModels: () => dispatch(getScoredModels()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
